import { render, staticRenderFns } from "./HouseTypeBaseInfo.vue?vue&type=template&id=d2afb058&scoped=true&"
import script from "./HouseTypeBaseInfo.vue?vue&type=script&lang=js&"
export * from "./HouseTypeBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./HouseTypeBaseInfo.vue?vue&type=style&index=0&id=d2afb058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2afb058",
  null
  
)

export default component.exports